type Props = {
  patientName: string;
  color: string;
  /** Horário alvo ao vivo — exibido em pill no topo do card. */
  targetStart: string;
  targetEnd: string;
};

/**
 * Card flutuante renderizado dentro do DragOverlay do @dnd-kit.
 * Posição segue o cursor via transform (GPU-accelerated, 60fps).
 * Zero re-render do grid enquanto arrasta.
 */
export function DragFloatingCard({
  patientName,
  color,
  targetStart,
  targetEnd,
}: Props) {
  return (
    <div
      className="pointer-events-none relative"
      style={{ minWidth: 160, maxWidth: 240 }}
    >
      {/* Pill de horário vivo — muda em tempo real conforme arrasta */}
      <div
        className="absolute -top-1.5 left-1/2 inline-flex -translate-x-1/2 -translate-y-full items-center whitespace-nowrap rounded-md px-2 py-0.5 text-[11px] font-bold tabular-nums text-white shadow-lg ring-1 ring-white/20"
        style={{ background: color }}
      >
        {targetStart} – {targetEnd}
      </div>

      {/* Card flutuante: shadow colorida em camadas pra profundidade sem
          peso visual. Alinhado reto — aparência profissional/clínica. */}
      <div
        className="rounded-[3px] px-2 py-1.5 text-[12px] font-semibold leading-tight text-zinc-900"
        style={{
          background: `${color}26`,
          borderLeft: `3px solid ${color}`,
          boxShadow: `0 10px 24px -6px ${color}66, 0 2px 6px -2px ${color}40, 0 0 0 1.5px ${color}`,
        }}
      >
        <div className="break-words">{patientName}</div>
      </div>
    </div>
  );
}
